import { render } from "./QuranPagesList.vue?vue&type=template&id=15230b69"
import script from "./QuranPagesList.vue?vue&type=script&lang=js"
export * from "./QuranPagesList.vue?vue&type=script&lang=js"
script.render = render

export default script